import axios from "axios";
import { ethers } from "ethers";

import { pinJSONArr } from "../hooks";

const mintBatchERC721APSI = async (contract, account, metadataToMint) => {
    const tokensAllocatedBN = await contract.totalSupply();
    const tokensMaxCap = await contract.MAX_SUPPLY();
    const tokensAllocated = tokensAllocatedBN.toNumber();
    const baseURI = await contract.baseURI();
    // const prefix = await contract.prefix();

    const maxSupplyDefined = tokensMaxCap.toNumber() > 0;
    const tokensLeft = maxSupplyDefined ? tokensMaxCap.sub(tokensAllocatedBN) : ethers.BigNumber.from(Number.MAX_SAFE_INTEGER);

    const mintTokenAmount = ethers.BigNumber.from(metadataToMint.length).lt(tokensLeft) ? metadataToMint.length : tokensLeft.toNumber();

    let pinData = [];

    const pendingTokensMetadata = [];
    if(tokensAllocated > 0) {
        for(let i = 0; i < tokensAllocated; i++) {
            const pendingMetadata = axios.get(`https://ipfs.io/ipfs/${baseURI}/${i}`, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(res => res.data);

            pendingTokensMetadata.push(pendingMetadata);
        }
    }

    const existingMetadataList = await Promise.all(pendingTokensMetadata);

    pinData = [...existingMetadataList, ...metadataToMint];

    const hash = await pinJSONArr(account, pinData);

    // One here pepresents uninitialised value of tx
    let tx = 1;
    let tokenIds = [];
    
    if(mintTokenAmount > 0) {
        await contract.setBaseURI(`${hash}`);

        const gas = await contract.estimateGas.mint(
            mintTokenAmount,
            [],
            "0x0000000000000000000000000000000000000000000000000000000000000000"
        ).catch((err) => {
            console.log(err);
            return "720000";
        });

        tx = await contract.mint(
            mintTokenAmount,
            [],
            "0x0000000000000000000000000000000000000000000000000000000000000000",
            { gasLimit: gas }
        ).catch(() => { return null });

        const tokensAllocated = tokensAllocatedBN.toNumber();
        for(let metedataTokenIndex = 0; metedataTokenIndex < mintTokenAmount; metedataTokenIndex++) {
            tokenIds.push(tokensAllocated + metedataTokenIndex + 1);
        }
    }

    return { tx, tokenIds }
};

export { mintBatchERC721APSI };